import React from 'react'
import _ from 'lodash'
import { Helmet } from 'react-helmet'

interface Props {
  route: {
    title: string
  }
}

const Component: React.FC<Props> = ({ route }) => {
  const title = _.isEmpty(route.title) ? 'CPSYMAP' : `${route.title} | CPSYMAP`
  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  )
}

export default Component
